export const ENABLE_WHATSAPP_NOTIFICATION_REQUEST = "ENABLE_WHATSAPP_NOTIFICATION_REQUEST";
export const ENABLE_WHATSAPP_NOTIFICATION_SUCCESS = "ENABLE_WHATSAPP_NOTIFICATION_SUCCESS";
export const ENABLE_WHATSAPP_NOTIFICATION_FAILURE = "ENABLE_WHATSAPP_NOTIFICATION_FAILURE";
export const ENABLE_WHATSAPP_NOTIFICATION_RESET = "ENABLE_WHATSAPP_NOTIFICATION_RESET";
export const enableWhatsappNotificationDataRequest = (payload) => ({
    type: ENABLE_WHATSAPP_NOTIFICATION_REQUEST,
    payload,
});
export const enableWhatsappNotificationDataSuccess = (payload) => ({
    type: ENABLE_WHATSAPP_NOTIFICATION_SUCCESS,
    payload,
});
export const enableWhatsappNotificationDataFailure = (error) => ({
    type: ENABLE_WHATSAPP_NOTIFICATION_FAILURE,
    payload: error,
});
export const enableWhatsappNotificationDataReset = () => ({
    type: ENABLE_WHATSAPP_NOTIFICATION_RESET,
});
